/**
 * HTTP Data API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Activity { 
    idData?: number;
    insertTs?: string;
    rawMessageId?: number;
    scts?: string;
    acquisitionTime?: string;
    idDevice?: number;
    idSensor?: number;
    originCode?: Activity.OriginCodeEnum;
    dataUploadSource?: Activity.DataUploadSourceEnum;
    extendedMessageType?: Activity.ExtendedMessageTypeEnum;
    activityModeCode?: Activity.ActivityModeCodeEnum;
    activityModeDt?: number;
    activity1?: number;
    activity2?: number;
    activity3?: number;
    temperature?: number;
}
export namespace Activity {
    export const OriginCodeEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeEnum = typeof OriginCodeEnum[keyof typeof OriginCodeEnum];
    export const DataUploadSourceEnum = {
        Provider: 'PROVIDER',
        Gdx: 'GDX',
        HttpUpload: 'HTTP_UPLOAD'
    } as const;
    export type DataUploadSourceEnum = typeof DataUploadSourceEnum[keyof typeof DataUploadSourceEnum];
    export const ExtendedMessageTypeEnum = {
        NoContact: 'NO_CONTACT',
        Mortality: 'MORTALITY',
        Status: 'STATUS',
        Null: 'NULL',
        Expelled: 'EXPELLED'
    } as const;
    export type ExtendedMessageTypeEnum = typeof ExtendedMessageTypeEnum[keyof typeof ExtendedMessageTypeEnum];
    export const ActivityModeCodeEnum = {
        NoActivityAvailable: 'NO_ACTIVITY_AVAILABLE',
        ActivityMeasurement300S: 'ACTIVITY_MEASUREMENT_300S',
        ActivityMeasurement152S: 'ACTIVITY_MEASUREMENT_152S',
        ActivityMeasurement64: 'ACTIVITY_MEASUREMENT_64',
        ActivityMeasurement: 'ACTIVITY_MEASUREMENT',
        HeadAngleAccelerationThreshold: 'HEAD_ANGLE_ACCELERATION_THRESHOLD',
        AccelerationPeakThreshold: 'ACCELERATION_PEAK_THRESHOLD',
        AvgFortBackUpDownRawData: 'AVG_FORT_BACK_UP_DOWN_RAW_DATA',
        TestModeA: 'TEST_MODE_A',
        TestModeB: 'TEST_MODE_B',
        TestModeC: 'TEST_MODE_C'
    } as const;
    export type ActivityModeCodeEnum = typeof ActivityModeCodeEnum[keyof typeof ActivityModeCodeEnum];
}


export type OriginCodeEnum = typeof Activity.OriginCodeEnum[keyof typeof Activity.OriginCodeEnum];
export type DataUploadSourceEnum = typeof Activity.DataUploadSourceEnum[keyof typeof Activity.DataUploadSourceEnum];
export type ExtendedMessageTypeEnum = typeof Activity.ExtendedMessageTypeEnum[keyof typeof Activity.ExtendedMessageTypeEnum];
export type ActivityModeCodeEnum = typeof Activity.ActivityModeCodeEnum[keyof typeof Activity.ActivityModeCodeEnum];
